import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import {
  FaSearch,
  FaFileExcel,
  FaColumns,
  FaChevronDown,
  FaChevronUp,
} from 'react-icons/fa';
import moment from 'moment';
import Header from '~/Components/Header/Header';
import './style.css';
import * as api from '~/Services/Service';
import { salvarEmExcel } from '~/Utils/Helpers';
import { toast } from 'react-toastify';
import {
  CHECKBOX_FIELDS,
  calcularDatasVinculo,
  criarEstadoInicialColunas,
} from './UtilsConvesaoLeads';
import FiltrosPrincipais from './FiltrosPrincipais';
import FiltrosAvancados from './FiltrosAvancados';
import ModalColunas from './ModalColunas';
import TabelaResultados from './TabelaResultados';
import ModalTags from './ModalTags';

const LIMITE_MESES_EXPORTACAO_EXCEL = 6;
const TAMANHO_PAGINA_RELATORIO = 50;

const CAMPOS_PERIODO_EXPORTACAO = [
  { inicio: 'data_vinculo_inicio', fim: 'data_vinculo_fim' },
  { inicio: 'data_cadastro_inicio', fim: 'data_cadastro_fim' },
  {
    inicio: 'data_conclusao_pasta_inicio',
    fim: 'data_conclusao_pasta_fim',
  },
  { inicio: 'data_nascimento_inicio', fim: 'data_nascimento_fim' },
];

const RelatorioProspectos = function() {
  const [filtrosAvancadosAberto, setFiltrosAvancadosAberto] = useState(false);
  const [modalColunasAberto, setModalColunasAberto] = useState(false);
  const [colunasForamAlteradas, setColunasForamAlteradas] = useState(false);
  const submitPendenteRef = useRef(null);
  const [dados, setDados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingEmp, setIsLoadingEmp] = useState(true);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [buscaRealizada, setBuscaRealizada] = useState(false);

  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const gerentesCorretores = useSelector(function(state) {
    return state.corretor;
  });

  const [empreendimentosOpts, setEmpreendimentosOpts] = useState([]);
  const [gerentesOpts, setGerentesOpts] = useState([]);
  const [corretoresOpts, setCorretoresOpts] = useState([]);

  const [cidadesOpts, setCidadesOpts] = useState([]);
  const [pdvOpts, set] = useState([]);
  const [modoRecebimentoOpts, setModoRecebimentoOpts] = useState([]);

  const [origemOpts, setOrigemOpts] = useState([]);
  const [profissaoOpts, setProfissaoOpts] = useState([]);
  const [statusOpts, setStatusOpts] = useState([]);
  const [atendenteOpts, setAtendenteOpts] = useState([]);
  const [canalOrigem, setCanalOrigem] = useState([]);
  const [midiaOrigem, setMidiaOrigem] = useState([]);

  const [modalTagsAberto, setModalTagsAberto] = useState(false);
  const estadoInicialColunas = useMemo(function() {
    return criarEstadoInicialColunas();
  }, []);
  const [colunasVisiveis, setColunasVisiveis] = useState(estadoInicialColunas);

  const [tagsProspecto, setTagsProspecto] = useState([]);
  const [codigoProspectoSelecionado, setCodigoProspectoSelecionado] = useState(
    null
  );

  const [ultimosFiltros, setUltimosFiltros] = useState(null);

  const datasVinculoPadrao = useMemo(function() {
    return calcularDatasVinculo();
  }, []);

  const periodoMaiorQueSeisMeses = function(values) {
    return CAMPOS_PERIODO_EXPORTACAO.some(function(periodo) {
      const dataInicio = values[periodo.inicio];
      const dataFim = values[periodo.fim];

      if (!dataInicio || !dataFim) {
        return false;
      }

      const dataInicioMoment = moment(dataInicio, 'DD/MM/YYYY', true);
      const dataFimMoment = moment(dataFim, 'DD/MM/YYYY', true);

      if (!dataInicioMoment.isValid() || !dataFimMoment.isValid()) {
        return false;
      }

      return (
        dataFimMoment.diff(dataInicioMoment, 'months', true) >
        LIMITE_MESES_EXPORTACAO_EXCEL
      );
    });
  };

  const prepararFiltrosConversaoLeads = function(valores) {
    const filtrosSanitizados = sanitizarFiltros(valores);
    filtrosSanitizados.terreno_construcao =
      valores.terreno_construcao_filtro || '';
    filtrosSanitizados.etapa_terreno_construcao =
      valores.etapa_terreno_construcao_filtro || null;
    delete filtrosSanitizados.terreno_construcao_filtro;
    delete filtrosSanitizados.etapa_terreno_construcao_filtro;

    return filtrosSanitizados;
  };

  const limparResultadosConversaoLeads = function() {
    setDados([]);
    setPaginaAtual(1);
    setTotalRegistros(0);
    setBuscaRealizada(false);
  };

  const dadosPaginados = useMemo(
    function() {
      return dados;
    },
    [dados]
  );

  const totalPaginas = useMemo(
    function() {
      return Math.ceil(totalRegistros / TAMANHO_PAGINA_RELATORIO);
    },
    [totalRegistros]
  );

  const buscarPaginaConversaoLeads = async function(filtrosBase, numeroPagina) {
    const filtrosPaginados = Object.assign({}, filtrosBase, {
      pagina: numeroPagina,
      tamanho_pagina: TAMANHO_PAGINA_RELATORIO,
    });

    const response = await api.buscarDadosConversaoLeads(filtrosPaginados);
    const itens =
      response && Array.isArray(response.itens)
        ? response.itens
        : response && Array.isArray(response.Itens)
        ? response.Itens
        : Array.isArray(response)
        ? response
        : [];

    let total = itens.length;
    if (
      response &&
      response.total_registros !== undefined &&
      response.total_registros !== null
    ) {
      total = Number(response.total_registros) || 0;
    } else if (
      response &&
      response.TotalRegistros !== undefined &&
      response.TotalRegistros !== null
    ) {
      total = Number(response.TotalRegistros) || 0;
    }

    setDados(itens);
    setTotalRegistros(total);
    setPaginaAtual(numeroPagina);
  };

  const mudarPagina = async function(numeroPagina) {
    if (
      !ultimosFiltros ||
      isLoading ||
      numeroPagina < 1 ||
      numeroPagina > totalPaginas ||
      numeroPagina === paginaAtual
    ) {
      return;
    }

    setIsLoading(true);

    try {
      await buscarPaginaConversaoLeads(ultimosFiltros, numeroPagina);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error) {
      console.error('Erro ao mudar página:', error);
      toast.error('Erro ao buscar a página selecionada.');
    } finally {
      setIsLoading(false);
    }
  };

  const valoresIniciaisFormulario = useMemo(
    function() {
      return Object.assign(
        {
          filtro: '',
          filtro_adicional: '',
          empreendimento: '',
          pdv: '',
          gerente: 'Todos',
          aceita_sms_whatsapp: 'Todos',
          modo_recebimento: 'Todos',
          data_vinculo_inicio: datasVinculoPadrao.inicio,
          data_vinculo_fim: datasVinculoPadrao.fim,
          data_cadastro_inicio: '',
          data_cadastro_fim: '',
          data_conclusao_pasta_inicio: '',
          data_conclusao_pasta_fim: '',
          data_nascimento_inicio: '',
          data_nascimento_fim: '',
          origem: 'Todos',
          cidade: '',
          profissao: '',
          status: 'Todos',
          sexo: 'Ambos',
          corretor: 'Todos',
          atendente: 'Todos',
          tipo_venda: 'Com e Sem Venda',
          documentacao: 'Todos',
          lote_interesse: '',
          tipo_cad: 'Todos',
          perfil_comprador: '',
          lancamento: '',
          canal_origem: '',
          midia_origem: '',
          interesse_social: '',
          terreno_construcao_filtro: '',
          etapa_terreno_construcao_filtro: '',
          senha: '',
          tarefas: '',
        },
        estadoInicialColunas
      );
    },
    [datasVinculoPadrao, estadoInicialColunas]
  );

  const sanitizarFiltros = function(values) {
    const filtrosSanitizados = {};

    const valoresParaVazio = ['todos', 'ambos', 'com e sem venda'];

    const camposData = [
      'data_vinculo_inicio',
      'data_vinculo_fim',
      'data_cadastro_inicio',
      'data_cadastro_fim',
      'data_conclusao_pasta_inicio',
      'data_conclusao_pasta_fim',
      'data_nascimento_inicio',
      'data_nascimento_fim',
    ];

    const converterData = function(dataStr) {
      if (!dataStr || dataStr.trim() === '') return '';
      const dataMoment = moment(dataStr, 'DD/MM/YYYY', true);
      if (!dataMoment.isValid()) return '';
      return dataMoment.format('YYYY-MM-DD');
    };

    Object.keys(values).forEach(function(key) {
      const valor = values[key];

      if (typeof valor === 'boolean' && key !== 'interesse_social') {
        return;
      }
      if (camposData.includes(key)) {
        filtrosSanitizados[key] = converterData(valor);
        return;
      }
      if (typeof valor === 'string') {
        const valorNormalizado = valor.toLowerCase().trim();
        if (valoresParaVazio.includes(valorNormalizado)) {
          filtrosSanitizados[key] = '';
        } else {
          filtrosSanitizados[key] = valor;
        }
        return;
      }
      if (valor && typeof valor === 'object' && 'value' in valor) {
        const valorNorm = String(valor.value)
          .toLowerCase()
          .trim();
        if (valoresParaVazio.includes(valorNorm)) {
          filtrosSanitizados[key] = '';
        } else {
          filtrosSanitizados[key] = valor.value;
        }
        return;
      }

      filtrosSanitizados[key] = valor;
    });

    return filtrosSanitizados;
  };

  // --- Carregamento de dados ---

  const empreendimentos = useSelector(function(state) {
    return state.empreendimentos;
  });

  useEffect(
    function() {
      try {
        const optionsEmpreendimentos = empreendimentos.sort.map(function(item) {
          return {
            value: item.codigo,
            label: item.codigo + ' - ' + item.descricao,
          };
        });
        setEmpreendimentosOpts([
          { value: '', label: 'Todos' },
          ...optionsEmpreendimentos,
        ]);
      } catch (err) {
        setEmpreendimentosOpts([{ value: '', label: 'Todos' }]);
      } finally {
        setIsLoadingEmp(false);
      }
    },
    [empreendimentos]
  );

  useEffect(
    function() {
      setIsLoadingEmp(
        empreendimentosOpts.length === 0 || empreendimentosOpts.length === 1
      );
    },
    [empreendimentosOpts]
  );

  useEffect(function() {
    const buscarModoRecebimento = async function() {
      try {
        const response = await api.getModoRecebimento();
        if (response && Array.isArray(response)) {
          const opts = response.map(function(item) {
            return {
              value: item.codigo || item.value,
              label: item.descricao || item.label,
            };
          });
          setModoRecebimentoOpts([{ value: '', label: 'Todos' }, ...opts]);
        } else {
          setModoRecebimentoOpts([{ value: '', label: 'Todos' }]);
        }
      } catch (err) {
        console.error('Erro ao buscar modo recebimento:', err);
        setModoRecebimentoOpts([{ value: '', label: 'Todos' }]);
      }
    };
    buscarModoRecebimento();
  }, []);

  useEffect(function() {
    const buscarCanalOrigem = async function() {
      try {
        const response = await api.getCanalOrigem();
        if (response) {
          const opts = response.map(function(item) {
            return { value: item.codigo, label: item.descricao };
          });
          setCanalOrigem(opts);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };
    buscarCanalOrigem();
  }, []);

  useEffect(function() {
    const buscarMidiaOrigem = async function() {
      try {
        const response = await api.getMidiaOrigem();
        if (response) {
          const opts = response.map(function(item) {
            return { value: item.codigo, label: item.descricao };
          });
          setMidiaOrigem(opts);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };
    buscarMidiaOrigem();
  }, []);

  useEffect(
    function() {
      try {
        const listaGerentes =
          gerentesCorretores && Array.isArray(gerentesCorretores.listaGerentes)
            ? gerentesCorretores.listaGerentes
            : [];
        const opts = listaGerentes.map(function(g) {
          const codigo = g.codigo;
          const nome = g.nome || g.nome_imobiliaria || '';
          const imobiliaria = g.nome_imobiliaria
            ? ' - ' + g.nome_imobiliaria
            : '';
          const label = (nome + imobiliaria).trim();
          return { value: String(codigo), label: label };
        });
        setGerentesOpts([{ value: '', label: 'Todos' }, ...opts]);
      } catch (err) {
        console.error('Erro ao montar gerentesOpts:', err);
        setGerentesOpts([{ value: '', label: 'Todos' }]);
      }
    },
    [gerentesCorretores]
  );

  useEffect(
    function() {
      try {
        const listaCorretores =
          gerentesCorretores &&
          Array.isArray(gerentesCorretores.listaCorretores)
            ? gerentesCorretores.listaCorretores
            : [];
        const opts = listaCorretores.map(function(c) {
          return { value: String(c.codigo), label: c.nome.trim() };
        });
        setCorretoresOpts([{ value: '', label: 'Todos' }, ...opts]);
      } catch (err) {
        console.error('Erro ao montar corretoresOpts:', err);
        setCorretoresOpts([{ value: '', label: 'Todos' }]);
      }
    },
    [gerentesCorretores]
  );

  useEffect(function() {
    const buscarOrigem = async function() {
      try {
        const response = await api.getOrigens();
        if (response && Array.isArray(response)) {
          const opts = response.map(function(item) {
            return {
              value: item.codigo || item.value,
              label: item.descricao || item.label,
            };
          });
          setOrigemOpts([{ value: '', label: 'Todos' }, ...opts]);
        } else {
          setOrigemOpts([{ value: '', label: 'Todos' }]);
        }
      } catch (err) {
        console.error('Erro ao buscar origem:', err);
        setOrigemOpts([{ value: '', label: 'Todos' }]);
      }
    };
    buscarOrigem();
  }, []);

  useEffect(function() {
    const buscarCidade = async function() {
      try {
        const response = await api.getCities();
        if (response && Array.isArray(response)) {
          const opts = response.map(function(item) {
            return { value: item.codigo, label: item.cidade };
          });
          setCidadesOpts([{ value: '', label: 'Todos' }, ...opts]);
        } else {
          setCidadesOpts([{ value: '', label: 'Todos' }]);
        }
      } catch (err) {
        console.error('Erro ao buscar cidades:', err);
        setCidadesOpts([{ value: '', label: 'Todos' }]);
      }
    };
    buscarCidade();
  }, []);

  useEffect(function() {
    const buscarProfissoes = async function() {
      try {
        const response = await api.getProfissoes();
        if (response && Array.isArray(response)) {
          const opts = response.map(function(item) {
            return {
              value: item.codigo || item.id,
              label: item.descricao || item.nome,
            };
          });
          setProfissaoOpts([{ value: '', label: 'Todas' }, ...opts]);
        } else {
          setProfissaoOpts([{ value: '', label: 'Todas' }]);
        }
      } catch (err) {
        console.error('Erro ao buscar profissões:', err);
        setProfissaoOpts([{ value: '', label: 'Todas' }]);
      }
    };
    buscarProfissoes();
  }, []);

  useEffect(function() {
    const buscarStatus = async function() {
      try {
        const response = await api.getStatus();
        if (response && Array.isArray(response)) {
          const opts = response.map(function(item) {
            return {
              value: item.codigo || item.value,
              label: item.descricao || item.label,
            };
          });
          setStatusOpts([{ value: '', label: 'Todos' }, ...opts]);
        } else {
          setStatusOpts([{ value: '', label: 'Todos' }]);
        }
      } catch (err) {
        console.error('Erro ao buscar status:', err);
        setStatusOpts([{ value: '', label: 'Todos' }]);
      }
    };
    buscarStatus();
  }, []);

  useEffect(function() {
    const buscarAtendentes = async function() {
      try {
        const response = await api.getAtendentesCAV();
        if (response && Array.isArray(response)) {
          const opts = response.map(function(item) {
            return {
              value: item.codigo || item.id,
              label: item.nome || item.descricao,
            };
          });
          setAtendenteOpts([{ value: '', label: 'Todos' }, ...opts]);
        } else {
          setAtendenteOpts([{ value: '', label: 'Todos' }]);
        }
      } catch (err) {
        console.error('Erro ao buscar atendentes:', err);
        setAtendenteOpts([{ value: '', label: 'Todos' }]);
      }
    };
    buscarAtendentes();
  }, []);

  // --- Handlers ---

  const aoSubmeterFormulario = async function(valores) {
    setIsLoading(true);

    try {
      const filtrosSanitizados = prepararFiltrosConversaoLeads(valores);
      setUltimosFiltros(filtrosSanitizados);
      await buscarPaginaConversaoLeads(filtrosSanitizados, 1);
      setBuscaRealizada(true);
    } catch (error) {
      console.error('Erro:', error);
      toast.error('Erro ao buscar dados de Conversão de Leads.');
    } finally {
      setIsLoading(false);
    }
  };

  const exportarParaExcel = async function(
    valoresCheckbox,
    filtrosParaExportacao
  ) {
    const filtrosExcel = filtrosParaExportacao || ultimosFiltros;

    if (!filtrosExcel) {
      toast.error('Realize uma busca antes de exportar.');
      return;
    }

    const colunasSelecionadas = CHECKBOX_FIELDS.filter(function(campo) {
      return valoresCheckbox[campo] === true;
    });

    if (colunasSelecionadas.length === 0) {
      toast.error('Selecione pelo menos uma coluna para exportar.');
      return;
    }

    setIsLoadingExcel(true);

    try {
      await salvarEmExcel(
        { Filtros: filtrosExcel, Colunas: colunasSelecionadas },
        '/relatorios/conversao/leads/exportar-excel'
      );
    } catch (error) {
      console.error('Erro ao exportar:', error);
      toast.error('Erro ao exportar para Excel.');
    } finally {
      setIsLoadingExcel(false);
    }
  };

  const abrirModalTags = function(codigoProspecto) {
    const prospecto = dados.find(function(d) {
      return d.codigo === codigoProspecto;
    });
    if (prospecto && prospecto.tags) {
      try {
        const tagsArray = JSON.parse(prospecto.tags);
        setTagsProspecto(tagsArray);
      } catch (error) {
        console.error('Erro ao parsear tags:', error);
        setTagsProspecto([]);
      }
    } else {
      setTagsProspecto([]);
    }
    setCodigoProspectoSelecionado(codigoProspecto);
    setModalTagsAberto(true);
  };

  const fecharModalTags = function() {
    setModalTagsAberto(false);
    setTagsProspecto([]);
    setCodigoProspectoSelecionado(null);
  };

  return (
    <div className="relatorio-prospectos">
      <Header title="Relatório Prospectos" />
      <Container fluid className="bg-white py-2">
        <Formik
          initialValues={valoresIniciaisFormulario}
          onSubmit={aoSubmeterFormulario}
        >
          {function(formikProps) {
            const values = formikProps.values;
            const handleSubmit = formikProps.handleSubmit;
            const setFieldValue = formikProps.setFieldValue;
            const periodoGrandeParaExcel = periodoMaiorQueSeisMeses(values);

            const allChecked = CHECKBOX_FIELDS.every(function(name) {
              return !!values[name];
            });

            const toggleAllCheckboxes = function() {
              const newVal = !allChecked;
              const novasColunasVisiveis = {};
              CHECKBOX_FIELDS.forEach(function(fieldName) {
                const valor = newVal || fieldName === 'nome';
                setFieldValue(fieldName, valor);
                novasColunasVisiveis[fieldName] = valor;
              });
              setColunasVisiveis(novasColunasVisiveis);
            };

            const executarBuscaOuExportacao = function() {
              if (!colunasForamAlteradas || periodoGrandeParaExcel) {
                submitPendenteRef.current = function() {
                  if (periodoMaiorQueSeisMeses(values)) {
                    const filtrosExportacao = prepararFiltrosConversaoLeads(
                      values
                    );
                    setUltimosFiltros(filtrosExportacao);
                    limparResultadosConversaoLeads();
                    exportarParaExcel(values, filtrosExportacao);
                    return;
                  }

                  handleSubmit();
                };
                setModalColunasAberto(true);
                return;
              }

              handleSubmit();
            };

            return (
              <Form onSubmit={handleSubmit}>
                <FiltrosPrincipais
                  values={values}
                  setFieldValue={setFieldValue}
                  origemOpts={origemOpts}
                  empreendimentosOpts={empreendimentosOpts}
                  isLoadingEmp={isLoadingEmp}
                  cidadesOpts={cidadesOpts}
                  profissaoOpts={profissaoOpts}
                  pdvOpts={pdvOpts}
                  statusOpts={statusOpts}
                  gerentesOpts={gerentesOpts}
                  corretoresOpts={corretoresOpts}
                  atendenteOpts={atendenteOpts}
                />

                <FiltrosAvancados
                  filtrosAvancadosAberto={filtrosAvancadosAberto}
                  values={values}
                  setFieldValue={setFieldValue}
                  modoRecebimentoOpts={modoRecebimentoOpts}
                  canalOrigem={canalOrigem}
                  midiaOrigem={midiaOrigem}
                  valoresIniciaisFormulario={valoresIniciaisFormulario}
                />

                <div
                  className="cl-actions-bar"
                  style={{ justifyContent: 'flex-end' }}
                >
                  <div className="cl-actions-group">
                    <Button
                      type="button"
                      variant="outline-secondary"
                      size="sm"
                      className="mr-2"
                      onClick={function() {
                        setModalColunasAberto(true);
                      }}
                      title="Colunas"
                      aria-label="Colunas"
                      style={{ fontSize: '0.8rem' }}
                    >
                      <FaColumns className="mr-1" size={12} />
                      <span className="cl-action-label">Colunas</span>
                    </Button>
                    <Button
                      type="button"
                      variant="outline-info"
                      size="sm"
                      className="mr-2"
                      onClick={function() {
                        setFiltrosAvancadosAberto(function(prev) {
                          return !prev;
                        });
                      }}
                      title="Filtros Avançados"
                      aria-label="Filtros Avançados"
                      style={{ fontSize: '0.8rem' }}
                    >
                      {filtrosAvancadosAberto ? (
                        <>
                          <FaChevronUp className="mr-1" size={10} />
                          <span className="cl-action-label">
                            Filtros Avançados
                          </span>
                        </>
                      ) : (
                        <>
                          <FaChevronDown className="mr-1" size={10} />
                          <span className="cl-action-label">
                            Filtros Avançados
                          </span>
                        </>
                      )}
                    </Button>
                    <Button
                      type="button"
                      variant="primary"
                      size="sm"
                      className="btn-buscar mr-2"
                      disabled={isLoading || isLoadingExcel}
                      style={{ fontSize: '0.8rem' }}
                      onClick={executarBuscaOuExportacao}
                      title="Buscar"
                      aria-label="Buscar"
                    >
                      <FaSearch className="mr-1" size={12} />
                      <span className="cl-action-label">Buscar</span>
                    </Button>
                    <Button
                      type="button"
                      variant="success"
                      size="sm"
                      disabled={
                        isLoadingExcel ||
                        !ultimosFiltros ||
                        !CHECKBOX_FIELDS.some(function(campo) {
                          return values[campo] === true;
                        })
                      }
                      onClick={function() {
                        exportarParaExcel(values);
                      }}
                      title={
                        !ultimosFiltros
                          ? 'Realize uma busca primeiro'
                          : !CHECKBOX_FIELDS.some(function(campo) {
                              return values[campo] === true;
                            })
                          ? 'Selecione pelo menos uma coluna'
                          : 'Exportar para Excel'
                      }
                      style={{ fontSize: '0.8rem' }}
                    >
                      <FaFileExcel className="mr-1" size={12} />
                      <span className="cl-action-label">
                        {isLoadingExcel ? 'Exportando...' : 'Excel'}
                      </span>
                    </Button>
                  </div>
                </div>

                <ModalColunas
                  mostrar={modalColunasAberto}
                  onFechar={function() {
                    setModalColunasAberto(false);
                    submitPendenteRef.current = null;
                  }}
                  onConfirmar={function() {
                    setColunasForamAlteradas(true);
                    setModalColunasAberto(false);
                    if (submitPendenteRef.current) {
                      submitPendenteRef.current();
                      submitPendenteRef.current = null;
                    }
                  }}
                  values={values}
                  setFieldValue={setFieldValue}
                  setColunasVisiveis={setColunasVisiveis}
                  allChecked={allChecked}
                  onToggleTodos={toggleAllCheckboxes}
                  exibirAvisoSomenteExcel={periodoGrandeParaExcel}
                />
              </Form>
            );
          }}
        </Formik>

        <TabelaResultados
          dados={dados}
          dadosPaginados={dadosPaginados}
          isLoading={isLoading}
          isLoadingExcel={isLoadingExcel}
          buscaRealizada={buscaRealizada}
          colunasVisiveis={colunasVisiveis}
          paginaAtual={paginaAtual}
          totalPaginas={totalPaginas}
          mudarPagina={mudarPagina}
          abrirModalTags={abrirModalTags}
        />
      </Container>

      <ModalTags
        mostrar={modalTagsAberto}
        onFechar={fecharModalTags}
        tagsProspecto={tagsProspecto}
        codigoProspectoSelecionado={codigoProspectoSelecionado}
      />
    </div>
  );
};

export default RelatorioProspectos;
